import { PASSPORT as Fetch, TRAIN as Fetch_Train } from '@/api'

// 请求用户信息
export const postUserInfo = (data) =>
  Fetch_Train({
    url: '/api/passport/user/info',
    method: 'post',
    data
  })

// 用户登录状态
export const postUserOnLine = (data) =>
  Fetch_Train({
    url: '/api/passport/user/online',
    method: 'post',
    data
  })
// web端用户登录状态
export const postUserOnLineWeb = (data) =>
  Fetch({
    url: '/api/passport/user/online',
    method: 'post',
    data
  })
// 用户信息——院校信息
export const getSchoolByName = (params) =>
  Fetch_Train({
    url: '/teacher-train-service/train/standard/getSchoolByName',
    method: 'post',
    params
  })

// 用户信息——教授专业
export const getMajorByName = (params) =>
  Fetch_Train({
    url: '/teacher-train-service/train/standard/getMajorClass',
    method: 'post',
    params
  })

// 转化 bimface
export const postBimFaceToken = (data) =>
  Fetch({
    url: '/front/preview/bimface/viewtoken',
    method: 'post',
    data
  })
